import { defineStore } from 'pinia'
import { useHttpStore } from './http'

export const useAuthStore = defineStore('auth', {
    state: () => {
        return {
            isAuthenticated: false,
            token: '',
            verifiedEmail: '',
            isAdmin: false,
            // Desafio de 2FA do login: o access_token so' chega apos confirmar o codigo.
            twoFactorChallenge: '',
            // Instante em que o codigo vence, nao quanto falta: a store e' persistida,
            // e uma duracao faria o cronometro reiniciar do zero a cada reload.
            twoFactorCodeExpiresAt: 0,
            recoverPassword: {
                email: '',
                attempts: 0,
                maxAttempts: 3
            }
        }
    },
    getters: {
        hasToken: () => localStorage.getItem('user-token') !== null,
        getToken: state => state.token,
        getAuthenticatedStatus: state => state.isAuthenticated,
    },
    actions: {
        setStatusAuthentication(status) {
            this.isAuthenticated = status
        },
        setToken(token) {
            this.token = token
        },
        setIsAdmin(isAdmin) {
            this.isAdmin = Boolean(isAdmin)
        },
        setTwoFactorChallenge({ challenge, expire_time }) {
            this.twoFactorChallenge = challenge
            this.twoFactorCodeExpiresAt = challenge
                ? Date.now() + Number(expire_time) * 1000
                : 0
        },
        // Sessao autenticada: usada tanto pelo login direto quanto pela confirmacao do 2FA.
        setSession(data) {
            localStorage.setItem('user-token', data.access_token)
            this.setToken(data.access_token)
            this.setIsAdmin(data.user?.is_admin)
            this.setStatusAuthentication(true)
            this.setTwoFactorChallenge({ challenge: '', expire_time: 0 })
        },
        async validateToken() {
            const httpStore = useHttpStore()
            let isValid = false

            await httpStore.apiOAuth
                .get(`/validate-token`)
                .then(() => {
                    this.setStatusAuthentication(true)
                    isValid = true
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        this.setStatusAuthentication(false)
                    }

                    isValid = false
                })

            return isValid
        },
        setVerifiedEmail(email) {
            this.recoverPassword.email = email
        }
    },
    persist: true
})
